export default __webpack_public_path__ + "static/media/custom-white-logo.9859c358.svg";